import { Table, Tbody, Td, Th, Thead, Tr } from '@ff-it/ui';
import { InvoiceRowKindIcon } from 'modules/invoicing/income/InvoiceRowKindIcon';
import { getRowTotal } from 'modules/invoicing/income/calculate';
import { ReactElement } from 'react';
import { useField } from 'react-final-form';
import Totals from 'routes/Agency/Invoices/Income/Form/Totals';
import { controlCol } from 'styles/style.css';
import { sepFormat, fmt } from 'utilities';

export function Preview(): ReactElement {
  const {
    input: { value: rows },
  } = useField<any[]>('rows', { subscription: { value: true } });

  return (
    <Table size="sm" variant="dark" mb="3">
      <Thead>
        <Tr>
          <Th className={controlCol} />
          <Th>Title</Th>
          <Th className="sum">Quantity</Th>
          <Th className="sum">Unit</Th>
          <Th className="sum">Unit price</Th>
          <Th className="sum">Total</Th>
          <Th className={controlCol}></Th>
        </Tr>
      </Thead>
      <Tbody>
        {rows.map(({ title, kind, quantity, unit, unit_price }, idx) => {
          const total = getRowTotal({ quantity, unit_price });
          return (
            <Tr key={idx}>
              <Td textAlign="center" valign="middle">
                <InvoiceRowKindIcon kind={kind} />
              </Td>
              <td>{title}</td>
              <Td className="sum" data-testid="quantity">
                {quantity}
              </Td>
              <Td className="sum">{unit}</Td>
              <Td className="sum" data-testid="unit_price">
                {sepFormat(unit_price)}
              </Td>
              <Td className="sum" data-testid="total">
                {fmt(total)}
              </Td>
              <Td />
            </Tr>
          );
        })}
      </Tbody>
      <Totals preview />
    </Table>
  );
}
